<div>
  <h2 mat-dialog-title>{{ data.title }}</h2>
  <mat-dialog-content class="mat-typography">
    <p><strong [innerHTML]="data.message"></strong></p>
  </mat-dialog-content>
  <mat-dialog-actions align="center">
    <button
      mat-button
      class="lum-button lum-button--secondary lum-button--medium w-30 mx-1"
      (click)="onCloseClick()"
    >
      Continue (ESC)
    </button>
  </mat-dialog-actions>
</div>
